import { render, staticRenderFns } from "./TasksWrapper.vue?vue&type=template&id=c249ed2a&scoped=true&"
import script from "./TasksWrapper.vue?vue&type=script&lang=js&"
export * from "./TasksWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TasksWrapper.vue?vue&type=style&index=0&id=c249ed2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c249ed2a",
  null
  
)

export default component.exports